import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF8A00',
    },
    secondary: {
      main: '#00E0FF',
    },
    background: {
      default: '#000000',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    h1: { fontSize: '3.2rem', fontWeight: 700 },
    h2: { fontSize: '2.2rem', fontWeight: 600 },
  },
});

export default theme;
